import React, { useState } from 'react';
import { AtSignIcon, LockIcon, UserIcon, CheckIcon } from 'lucide-react';
import { SignupData } from '../../pages/SignupPage';
interface SignupFormProps {
  onNext: () => void;
  updateData: (data: Partial<SignupData>) => void;
  data: SignupData;
}
const SignupForm: React.FC<SignupFormProps> = ({
  onNext,
  updateData,
  data
}) => {
  const [errors, setErrors] = useState<Record<string, string>>({});
  const validate = () => {
    const newErrors: Record<string, string> = {};
    if (!data.email) newErrors.email = 'Email is required';else if (!/\S+@\S+\.\S+/.test(data.email)) newErrors.email = 'Email is invalid';
    if (!data.password) newErrors.password = 'Password is required';else if (data.password.length < 8) newErrors.password = 'Password must be at least 8 characters';
    if (!data.fullName) newErrors.fullName = 'Full name is required';
    if (!data.username) newErrors.username = 'Username is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validate()) {
      onNext();
    }
  };
  return <div className="p-4" data-id="element-217">
      <p className="text-gray-600 text-center mb-6" data-id="element-218">
        Create your account to connect with athletes, coaches, and teams
      </p>
      <form onSubmit={handleSubmit} data-id="element-219">
        <div className="space-y-4" data-id="element-220">
          <div className="relative" data-id="element-221">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-222">
              <AtSignIcon size={18} className="text-gray-500" data-id="element-223" />
            </div>
            <input type="email" className={`bg-gray-50 border ${errors.email ? 'border-red-500' : 'border-gray-300'} text-gray-900 text-sm rounded-lg block w-full pl-10 p-2.5`} placeholder="Email address" value={data.email} onChange={e => updateData({
            email: e.target.value
          })} data-id="element-224" />
            {errors.email && <p className="text-red-500 text-xs mt-1" data-id="element-225">{errors.email}</p>}
          </div>
          <div className="relative" data-id="element-226">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-227">
              <LockIcon size={18} className="text-gray-500" data-id="element-228" />
            </div>
            <input type="password" className={`bg-gray-50 border ${errors.password ? 'border-red-500' : 'border-gray-300'} text-gray-900 text-sm rounded-lg block w-full pl-10 p-2.5`} placeholder="Password" value={data.password} onChange={e => updateData({
            password: e.target.value
          })} data-id="element-229" />
            {errors.password && <p className="text-red-500 text-xs mt-1" data-id="element-230">{errors.password}</p>}
          </div>
          <div className="relative" data-id="element-231">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-232">
              <UserIcon size={18} className="text-gray-500" data-id="element-233" />
            </div>
            <input type="text" className={`bg-gray-50 border ${errors.fullName ? 'border-red-500' : 'border-gray-300'} text-gray-900 text-sm rounded-lg block w-full pl-10 p-2.5`} placeholder="Full name" value={data.fullName} onChange={e => updateData({
            fullName: e.target.value
          })} data-id="element-234" />
            {errors.fullName && <p className="text-red-500 text-xs mt-1" data-id="element-235">{errors.fullName}</p>}
          </div>
          <div className="relative" data-id="element-236">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-237">
              <AtSignIcon size={18} className="text-gray-500" data-id="element-238" />
            </div>
            <input type="text" className={`bg-gray-50 border ${errors.username ? 'border-red-500' : 'border-gray-300'} text-gray-900 text-sm rounded-lg block w-full pl-10 p-2.5`} placeholder="Username" value={data.username} onChange={e => updateData({
            username: e.target.value
          })} data-id="element-239" />
            {errors.username && <p className="text-red-500 text-xs mt-1" data-id="element-240">{errors.username}</p>}
          </div>
          <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg text-sm px-5 py-3 text-center" data-id="element-241">
            Continue
          </button>
        </div>
      </form>
      <div className="mt-6 text-center text-sm text-gray-500" data-id="element-242">
        Already have an account?{' '}
        <a href="/login" className="text-blue-600 font-medium" data-id="element-243">
          Log in
        </a>
      </div>
    </div>;
};
export default SignupForm;